import React, { useEffect } from 'react';
import { Text, VStack } from '@chakra-ui/react';
import {
  useGetModelsCarsQuery,
  useLazyGetModelTableDataQuery,
} from '@spartalabs/pdc-core';
import { MultiInfoCard } from 'components';
import TableCard from 'components/Cards/TableCard';
import { DelayAnimation } from 'shared/DelayAnimation';
import { ModelFilters } from 'utils/constants';
import { downloadFile } from 'utils/functions';
import { ModelTable } from './consts';

export const Models: React.FC = () => {
  const {
    data: modelsData,
    isFetching: isFetchingModels,
    isLoading: isLoadingModels,
    isError: isErrorModels,
    refetch: refetchModels,
  } = useGetModelsCarsQuery();

  const [
    fetchTable,
    {
      data: tableData,
      isLoading: isLoadingTable,
      isFetching: isFetchingTable,
      isError: isErrorTable,
    },
  ] = useLazyGetModelTableDataQuery();

  useEffect(() => {
    fetchTable({ page: 1, quantity: 5, term: '' });
  }, []);

  return (
    <DelayAnimation>
      <VStack
        px={{ base: '16px', md: '32px' }}
        pb="20px"
        flex={1}
        spacing="20px"
        fontSize="xl"
      >
        <MultiInfoCard
          loading={isLoadingModels || isFetchingModels}
          canHaveShowMore
          w="100%"
          customTitle={
            <Text
              alignSelf="center"
              color="text.100"
              fontSize="16px"
              fontWeight={400}
            >
              Distribuição da <b>frota por modelo</b>
            </Text>
          }
          subtitle="Modelos e quantidade"
          data={modelsData}
          isError={isErrorModels}
          refetch={refetchModels}
        />
        <TableCard
          loading={isLoadingTable || isFetchingTable}
          fetchData={fetchTable}
          fetchDownload={async () => await downloadFile('models', 'Modelos')}
          hasGlobalSearch
          customTitle={
            <Text
              alignSelf="center"
              color="text.100"
              fontSize="16px"
              fontWeight={400}
            >
              Relatório de <b>Veículos</b>
            </Text>
          }
          subtitle="Modelos de veículos"
          overflowX="auto"
          w="100%"
          filters={ModelFilters}
          labels={ModelTable}
          data={tableData}
          analyticsId="Todos os veículos"
          isError={isErrorTable}
          refetch={fetchTable}
        />
      </VStack>
    </DelayAnimation>
  );
};
